import React, { memo } from 'react';

import { Skeleton, ProductsArea, ProductPlaceholder, FlexColumn } from './styles';

//constants
const DEFAULT_PAGE_SIZE = 16;
const PagePlaceholder = () => {
  return (
    <Skeleton>
      <FlexColumn>
        <ProductsArea>
          {Array(DEFAULT_PAGE_SIZE)
            .fill('_')
            .map((_, index) => (
              <ProductPlaceholder key={index}></ProductPlaceholder>
            ))}
        </ProductsArea>
      </FlexColumn>
    </Skeleton>
  );
};

export default memo(PagePlaceholder);
